import React, { useCallback, useContext } from 'react'
import ServiceSection from './ServiceSection'
import { ServiceRequestContext } from '../ServiceRequestContext'
import MemberSection from '../../Common/Input/MemberSearch'
import UserContext, { Roles } from '../../../UserContext'
import type { ServiceRequestService, ServiceRequestMember } from '../../../models'

type DetailProps = { serviceRequestService: ServiceRequestService }

const Detail: React.FC<DetailProps> = () => {
    const userContext = useContext(UserContext)
    const { readOnly, setSelectedService, selectedService } = useContext(ServiceRequestContext)

    const onMemberSelected = useCallback((member: ServiceRequestMember) => {
        setSelectedService({ ...selectedService, member: member })
    }, [selectedService, setSelectedService])

    return (
        <>
            {!userContext.hasAnyRole(Roles.Provider)
                && <MemberSection serviceRequestMember={selectedService ? selectedService.member : undefined}
                    onMemberSelected={onMemberSelected}
                    includeAddress={false} />}
            {selectedService?.member && <ServiceSection providerView={userContext.hasAnyRole(Roles.Provider)} readOnly={readOnly} />}
        </>
    )
}

export default Detail
